<style lang="scss" scoped>
.row {
    height: 395px;
}
</style>

<template>
    <div class="row">
        <div
            class="container-fluid bg-accent d-flex flex-column align-items-center justify-content-center px-32 px-lg-12 text-center"
        >
            <h2 class="text-white mb-32">{{ text }}</h2>
            <div>
                <a :href="dayConfigurator" class="btn btn-white">
                    {{
                        hasTemplateUrl
                            ? "Stel deze dag samen"
                            : "Stel zelf je dag samen"
                    }}
                </a>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    name: "pageParts.quote-or-list",

    props: {
        text: {
            type: String,
            default: "Al goesting om het zelf te doen?"
        },
        activity: {
            type: Object,
            required: true,
            default: () => {}
        }
    },

    data: vm => ({
        orders: {
            activities: [vm.activity]
        }
    }),

    computed: {
        hasTemplateUrl() {
            return (
                this.activity.acf.content.template_url &&
                this.activity.acf.content.template_url !== ""
            );
        },

        dayConfigurator() {
            if (this.hasTemplateUrl) {
                return this.activity.acf.content.template_url;
            }

            return route("nl.day-configurator");
        }
    }
};
</script>
